import { CountryCode } from './type';
import type { Country } from './type';

export const hongKong: Country = {
    name: 'Hong Kong',
    nameFull: 'Hong Kong',
    code: CountryCode.HK,
    displayCode: CountryCode.HK,
    combinedDisplayCode: CountryCode.HK,
    makeMethod: 'makeHongKong',
    theme: false,
    currency: '$',
    currencyName: 'HKD',
    currencyWithCountry: 'HK$',
    maxImageSize: 20000000, // 20MB
    imageOptions: {
        maxSize: 20000000,
        fileType: []
    },
    maxGoodNumberPerClass: 100,
    paymentMethodsImageName: 'image-4-card',
    stripeKey: import.meta.env.VITE_STRIP_PUBLIC_KEY_HK,
    autoSelectedInForm: true,
};
